module.exports = __webpack_public_path__ + "img/7.f066be44.png";